import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createReduxEnhancer } from '@sentry/react'
import rootReducer from './index'

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk), createReduxEnhancer()),
)

export default store
